import { render, staticRenderFns } from "./EscalaRepeticao.vue?vue&type=template&id=19e6f3b7&"
import script from "./EscalaRepeticao.vue?vue&type=script&lang=js&"
export * from "./EscalaRepeticao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports